import styled, { css } from "styled-components";

import { Breakpoint, screenBelow } from "../BreakPoints";
import { Align, FLEX_ALIGN, Space, SPACE } from "../LayoutTokens";

export const StyledColumns = styled.div<{
  $space: Space;
  $alignY: Align;
  $collapse?: Breakpoint;
}>`
  display: flex;
  flex-direction: row;
  align-items: ${({ $alignY }) => FLEX_ALIGN[$alignY]};
  gap: ${({ $space }) => SPACE[$space]};

  > .c-columns-col {
    min-width: 0;
  }

  ${({ $collapse }) =>
    $collapse &&
    css`
      ${screenBelow[$collapse]} {
        flex-direction: column;
        align-items: stretch;

        /* The column flex weight is an inline style, so it needs the override. */
        > .c-columns-col {
          flex: 0 0 auto !important;
          width: 100%;
        }
      }
    `}
`;

StyledColumns.displayName = "StyledColumns";
